export const mapOptionsToStore = data => {
  let folders = [];
  if (_.isArray(data)) {
    folders = data.map(folder => {
      let slot = [];
      // parse folder data
      if (_.isArray(folder.dashboards)) {
        // parse slot data
        slot = folder.dashboards.map(value => ({
          id: value.id,
          name: value.name,
          dashboardFolderId: value.dashboard_folder_id,
          updated: value.is_new_update,
        }));
      }
      return {
        id: `folder-${folder.id}`,
        name: folder.name,
        slots: slot,
      };
    });
  }
  return folders;
};

export const setSlotUpdate = (slots, selectedSlotId, updating = false) => (
  slots.map(slot => {
    if (slot.id === selectedSlotId) {
      return {
        ...slot,
        is_refreshing: updating,
      };
    }
    return slot;
  })
);

export const setDashboardUpate = (dashboard, dashboardId, updating = false) => {
  const slots = dashboard.dashboard_slots.map(slot => ({
    ...slot,
    is_refreshing: updating,
  }));
  return {
    ...dashboard,
    is_refreshing: updating,
    dashboard_slots: slots,
  };
};

export const setSlotData = (slotId, slots, updatedSlotData) => slots.map(slot => {
  if (slot.id === slotId) {
    return updatedSlotData;
  }
  return slot;
});



// WEBPACK FOOTER //
// ./src/views/Dashboard/flow/utils.js